import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../ui/Icon';
import styles from './Sidebar.module.css';

const NAV = [
  {
    section: 'Overview',
    items: [
      { to: '/',          icon: 'dashboard',      label: 'Dashboard' },
      { to: '/analytics', icon: 'bar_chart',       label: 'Analytics' },
    ],
  },
  {
    section: 'Marketing',
    items: [
      { to: '/campaigns', icon: 'campaign',        label: 'Campaigns', badge: '4', badgeType: 'red' },
      { to: '/journeys',  icon: 'route',           label: 'Journeys' },
      { to: '/segments',  icon: 'group',           label: 'Segments' },
      { to: '/abtests',   icon: 'science',         label: 'A/B Tests', badge: 'Soon', badgeType: 'soon', disabled: true },
    ],
  },
  {
    section: 'Channels',
    items: [
      { to: '/push',      icon: 'notifications',   label: 'Push Notifications' },
      { to: '/inapp',     icon: 'phone_iphone',    label: 'In-App Messages', badge: '2', badgeType: 'green' },
      { to: '/whatsapp',  icon: 'chat',            label: 'WhatsApp' },
    ],
  },
  {
    section: 'Platform',
    items: [
      { to: '/events',   icon: 'bolt',             label: 'Events' },
      { to: '/settings', icon: 'settings',         label: 'Settings' },
    ],
  },
];

class Sidebar extends React.Component {
  render() {
    return (
      <aside className={styles.sidebar}>
        <div className={styles.logoWrap}>
          <div className={styles.logoGem}>
            <svg viewBox="0 0 16 16"><path d="M8 1L1 6l7 9 7-9z" opacity=".9"/><path d="M1 6h14" stroke="#fff3" strokeWidth=".5" fill="none"/></svg>
          </div>
          <span className={styles.logoName}>PMW Click</span>
          <span className={styles.logoVer}>v2.1</span>
        </div>

        <nav className={styles.nav}>
          {NAV.map(group => (
            <div key={group.section} className={styles.navSec}>
              <div className={styles.navSecLbl}>{group.section}</div>
              {group.items.map(item => (
                item.disabled ? (
                  <div
                    key={item.to}
                    className={[styles.navItem, styles.navItemDisabled].join(' ')}
                    title="Coming soon"
                  >
                    <span className={styles.navIcon}>
                      <Icon name={item.icon} size={16} />
                    </span>
                    {item.label}
                    {item.badge && (
                      <span className={[styles.nb, styles['nb' + item.badgeType]].join(' ')}>
                        {item.badge}
                      </span>
                    )}
                  </div>
                ) : (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === '/'}
                    className={({ isActive }) =>
                      [styles.navItem, isActive ? styles.active : ''].join(' ')
                    }
                  >
                    <span className={styles.navIcon}>
                      <Icon name={item.icon} size={16} />
                    </span>
                    {item.label}
                    {item.badge && (
                      <span className={[styles.nb, styles['nb' + item.badgeType]].join(' ')}>
                        {item.badge}
                      </span>
                    )}
                  </NavLink>
                )
              ))}
            </div>
          ))}
        </nav>
      </aside>
    );
  }
}

export default Sidebar;
